export const formatStoreOperatingRatio = (operatingStoreCount, totalStoreCount) => {
  const total = Number(totalStoreCount);
  if (!Number.isFinite(total) || total <= 0) {
    return '0%';
  }
  const operating = Number(operatingStoreCount);
  const ratio = Math.round(((Number.isFinite(operating) ? operating : 0) / total) * 1000) / 10;
  return `${ratio}%`;
};

export const formatStoreAmountWan = (amount) => {
  if (amount === null || amount === undefined || amount === '') {
    return null;
  }
  const number = Number(amount);
  return Number.isFinite(number) ? Math.round((number / 10000) * 100) / 100 : null;
};

export const formatStoreTargetDescription = (amount) => {
  const amountWan = formatStoreAmountWan(amount);
  return amountWan === null ? '本月目标 -' : `本月目标 ${amountWan.toFixed(2)} 万`;
};
